<template>
  <div class="pt-0 pb-2 px-3" style="position:fixed;">

    <div v-if="loading" class="text-center py-3"><i class="fas fa-spinner fa-spin fa-2x"></i></div>

      <div class="flex-container">
        <div v-for="list in lists" :key="list.id" class="flex-item">
        <div class="py-2"><b>{{list.name}}</b></div>
        <draggable
          class="list-group hotspot"
          v-model="list.items"
          v-bind="dragOptions"
          :move="onMove"
          :list-id="list.id"
          :list-name="list.name">
          <li class="list-group-item" v-for="element in list.items" :key="element.id">
            {{ element.name }} <a :href="`/category/${element.id}/category`" target="_blank" class="bullet">•</a>
          </li>
        </draggable>
      </div>
  </div>
  
  </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
  components: {
    draggable,
  },
  data() {
    return {
      lists: [],
      loading: false,
      editable: true,
      isDragging: false,
      delayedDragging: false,
    };
  },

   mounted() {
    this.getLists();
  },

  methods: {

    getLists() {

      this.loading = true;

      axios.get('/category/all').
      then((response) => {
        this.lists = response.data;
        this.loading = false;
      });

    },

    onMove({ relatedContext, draggedContext }) {
      const relatedElement = relatedContext.element;
      const draggedElement = draggedContext.element;

      if (relatedContext.component !== draggedContext.component) {
        const targetListId = relatedContext.component.$attrs['list-id'];
        this.updateCategory(draggedElement.id, targetListId);
      }

      return (
        (!relatedElement || !relatedElement.fixed) && !draggedElement.fixed
      );
    },

    updateCategory(categoryId, listId) {
      axios.post('/category/update', {
        category_id: categoryId,
        list_id: listId
      }).then((response) => {
        console.log(response.data);
      });
    },

  },
  computed: {
    dragOptions() {
      return {
        animation: 0,
        group: "description",
        disabled: !this.editable,
        ghostClass: "ghost",
      };
    },
  },
  watch: {
    isDragging(newValue) {
      if (newValue) {
        this.delayedDragging = true;
        return;
      }
      this.$nextTick(() => {
        this.delayedDragging = false;
      });
    },
  },
};
</script>


<style>
.bullet {
  font-size: 40px;
  line-height: 0;
  position: relative;
  top: 0.64rem;
}
.flex-container {
    column-count: 6; /* Adjust the number of columns based on your design */
    column-gap: 1rem; /* Space between columns */
    width: 100%; /* Full width of the container */
}

.flex-item {
    break-inside: avoid; /* Prevent items from splitting across columns */
    background-color: #f2f2f2; /* Example background color */
    margin-bottom:20px;
    max-height: 250px;
    overflow: scroll;
}

.hotspot {
  background: #fff;
  border: 1px dashed #000;
  padding: 10px;
  border-radius: 0px;
}
.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 1;
  background: #eeff00;
}

.list-group {
  min-height: 10px;
}

.list-group-item {
  cursor: move;
  padding: 0px 10px;
  font-size: 0.8rem;
}

.list-group-item i {
  cursor: pointer;
}
</style>